import React from 'react';
import './ModalCarga.css'; // Estilos separados para poder reutilizar

export const ModalCarga = () => {
  return (
    <div className="spinner-backdrop">
      <div className="spinner" />
    </div>
  );
};
